var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 124,
    viewBox: "0 0 123 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-2 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1635 85.6904C20.1635 86.8642 20.9392 88.0382 22.4904 88.9338C25.593 90.7253 30.6233 90.7253 33.7259 88.9338C35.2771 88.0382 36.0531 86.8642 36.0531 85.6904L42.2069 69.7321L17.9375 67.3418L20.1635 85.6904Z",
    fill: "#D3135A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.7168 101.981C48.7168 103.281 49.5751 104.58 51.2921 105.571C54.7257 107.553 60.2927 107.553 63.7264 105.571C65.4433 104.58 66.3019 103.28 66.3017 101.981L74.9102 79.0254H41.582L48.7168 101.981Z",
    fill: "#D3135A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M88.8457 77.7368C88.8457 78.9241 89.6301 80.1115 91.199 81.0174C94.3372 82.8293 99.4251 82.8293 102.563 81.0174C104.133 80.1118 104.917 78.9243 104.917 77.7368L111.084 54.3438L88.9476 59.1785L88.8457 77.7368Z",
    fill: "#D3135A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M46.101 23.6869C16.3521 38.8423 12.9246 61.4361 22.2758 77.2919C27.0612 84.5436 48.2487 101.056 81.2504 86.6178C111.165 73.6624 116.163 46.699 109.649 34.4343C98.9305 14.9345 70.8713 12.3332 46.101 23.6869Z",
    fill: "#F9BED2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.6696 23.7781C22.2074 24.1204 20.961 24.9286 20.4777 27.4974C19.9648 30.7595 22.1406 36.5963 22.9937 42.6334C26.5061 38.5732 28.7742 39.45 35.1995 40.1414C35.4875 40.1724 36.0014 38.8377 35.9055 38.5244C35.9055 38.5246 27.074 20.5152 22.6696 23.7781Z",
    fill: "#D3135A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.0465 24.9134C17.642 28.1763 21.3801 37.5103 22.3331 44.2552C26.0029 40.0131 28.2248 39.3114 35.1993 40.1426C35.1993 40.1426 26.4509 21.6505 22.0465 24.9134Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M28.5737 58.642C25.6525 56.9553 23.0272 56.9042 21.2189 58.188C21.0229 58.3271 13.002 64.1302 13.002 64.1302L26.0337 86.0443C26.0337 86.0443 35.7716 82.0168 35.9287 81.9053C37.4967 80.7919 38.4507 78.6744 38.4507 75.7491C38.4507 69.4504 34.0287 61.7912 28.5737 58.642Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.8639 64.4406C14.8757 61.5607 10.832 63.8953 10.832 69.6549C10.832 75.415 14.8757 82.4185 19.8639 85.2985C24.8519 88.1782 28.8957 85.8438 28.8957 80.0839C28.8957 74.3243 24.8519 67.3205 19.8639 64.4406Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.2601 70.3939C14.019 69.6772 13.1777 70.3751 13.1777 71.8084C13.1777 73.2416 14.0186 74.7551 15.2598 75.4717C16.5009 76.1883 17.5072 75.7194 17.5072 74.2864C17.5072 72.8531 16.5011 71.1105 15.2601 70.3939Z",
    fill: "#C2185B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M22.7254 74.704C21.4841 73.9873 20.6445 74.5562 20.6445 75.9897C20.6445 77.4229 21.4841 79.0361 22.7254 79.7525C23.9665 80.4691 24.9726 80.0295 24.9726 78.5962C24.9726 77.1632 23.9665 75.4206 22.7254 74.704Z",
    fill: "#C2185B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.8538 71.1763C13.8538 70.7292 13.9518 70.365 14.124 70.0977C13.4605 70.1654 13.0137 70.7386 13.0137 71.6921C13.0137 73.1253 14.02 74.868 15.2611 75.5846C16.1151 76.0776 16.8579 75.9563 17.238 75.366C16.9043 75.4001 16.5165 75.3086 16.1009 75.0688C14.8601 74.3522 13.8538 72.6096 13.8538 71.1763Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M46.123 44.2561C55.0523 44.9342 57.1337 54.4927 59.5012 59.7983C59.6463 60.1235 60.9563 58.2267 61.5675 57.6734C64.4962 51.5234 65.6676 39.7339 62.4422 35.3018C59.2168 30.87 46.123 44.2561 46.123 44.2561Z",
    fill: "#D3135A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21.3184 75.4871C21.3184 75.04 21.4164 74.6761 21.5886 74.4082C20.9251 74.4762 20.4785 75.0491 20.4785 76.0029C20.4785 77.4361 21.4846 79.1788 22.7257 79.8954C23.5797 80.3886 24.3223 80.2673 24.7026 79.6768C24.3689 79.7109 23.9809 79.6196 23.5655 79.3796C22.3242 78.663 21.3184 76.9203 21.3184 75.4871Z",
    fill: "#F06292"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M46.123 44.2549C53.0264 45.55 57.2699 54.6508 59.5012 59.7971C62.4299 53.6472 63.6013 41.8576 60.3759 37.4258C57.1505 32.9937 46.123 44.2549 46.123 44.2549Z",
    fill: "#F06292"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M47.2832 32.0895L54.0564 33.5489C63.6967 24.4962 78.9259 22.1082 78.9259 22.1082L73.192 19.666C57.7423 22.6922 47.2832 32.0895 47.2832 32.0895Z",
    fill: "#C2185B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M73.2178 23.4495C76.6121 22.4708 78.9253 22.1082 78.9253 22.1082L73.1914 19.666L73.2178 23.4495Z",
    fill: "#F06292"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.e77a4e8bd67c995faee2981d780eb725.svg";
export { ForwardRef as ReactComponent };